module.exports = __webpack_public_path__ + "media/images/discount_background-95685d8e20d3865a7f16692ce30833bc.png";